export const getPrompt = {
  PERSONA_SECTION: ({ cardName, personaName, occupation, age, gender, originalContent }) => `Base on the persona ${personaName} and the section ${cardName}, as a CX expert I want to generate a text that will help me to fill the section ${cardName} with relevant content. Details on Persona: Name:${personaName} , profession: ${occupation}, age: ${age} Gender:${gender}. you're response should be to the point and not more than 200 words. Do not mention that you're a CX expert. if the ${cardName} is for example Interest, provide straight the interest of the persona. if the ${cardName} is for example Frustrations, provide straight the frustrations of the persona. ${originalContent ? `Here is the original content you can be inspired about ${originalContent}` : ''} [End].`,
  PERSONA_CREATION_EXTRACT_DETAILS: ({ prompt }) => {
    return `Analyze the given text: "${prompt}".
    Your task is to identify and extract specific details for the creation of persona as a CX professional, including the person's name, age, profession, gender, language, context, and location.
    Use the provided text to determine the "Language" field, and infer the gender based on the name, defaulting to "Man", "Woman", or "Other" if the gender is not explicitly mentioned or cannot be inferred.
    For any missing information, use "Unknown". Structure your response in JSON format.

    Note: The "Language" field should represent the language in which the text is written.
    The "Context" field should represent the situation or activity the person is involved in.

    Example input:
    "Robert Makerson is a Marketing manager taking a bank loan. He is 35 years old, he lives in New York."

    Expected output in a variable:
    {
      "name": "Robert Makerson",
      "age": "35",
      "profession": "Marketing Manager",
      "gender": "Man",
      "language": "English",
      "context": "Taking a Bank Loan",
      "location": "New York"
    };

    Example input:
    "Sarah is a hospital purchase manager buying medical equipment. She is 28 years old and lives in Paris."

    Expected output in a variable:
    {
      "name": "Sarah",
      "age": "28",
      "profession": "Hospital Purchase Manager",
      "gender": "Woman",
      "language": "English",
      "context": "Buying Medical Equipment",
      "location": "Paris"
    };

    Example input:
    "Jennifer london 26 product manager"
    Expected output in a variable:
    {
      "name": "Jennifer",
      "age": "26",
      "profession": "Product manager",
      "gender": "Woman",
      "language": "English",
      "context": "Unknown",
      "location": "London (UK)"
    };


    Ensure each field is accurately captured in the JSON structure: name, age, profession, gender, language, context, and location. If any detail is not mentioned, represent it with "Unknown".`
  },

  PERSONA_SECTION_TEXT: ({ cardName, personaName, occupation, age, gender, originalContent, language = 'English' }) => `Given the persona details and a section title, generate concise, relevant content tailored to the specified section for the persona. The response should be direct and under 200 words, closely fitting the theme of the section.

    **Persona Details:**
    - Name: ${personaName}
    - Profession: ${occupation}
    - Age: ${age}
    - Gender: ${gender}

    **Section Title:** ${cardName}

    **Original Content for Inspiration (if available):** ${originalContent ? `"${originalContent}"` : "Not provided"}
    **Your response has to be in ${language}:**

    **Guidance with Examples:**
    - Tailor your response to directly fit the section's theme. For instance:
      - If the section is "Interests", directly list the persona's interests.
      - If the section is "Frustrations", directly outline the persona's frustrations.
    - The aim is to fill the section with content that is immediately relevant and useful, avoiding unnecessary introductions or conclusions.

    Please craft your response with the above persona details and guidance in mind, ensuring it adheres to the word limit and directly addresses the section's theme.

    `,
  PERSONA_SECTION_TEXT_GROUP: ({ cardName, personaName, occupation, age, originalContent, language = 'English' }) => `Given the persona details and a section title, generate concise, relevant content tailored to the specified section for the persona. The response should be direct and under 200 words, closely fitting the theme of the section.The Persona represent a group of people.

    **Persona Details:**
    - Title: ${personaName}
    - Profession: ${occupation}
    - Age: ${age}

    **Section Title:** ${cardName}

    **Original Content for Inspiration (if available):** ${originalContent ? `"${originalContent}"` : "Not provided"}
    **Your response has to be in ${language}:**

    **Guidance with Examples:**
    - Tailor your response to directly fit the section's theme. For instance:
      - If the section is "Interests", directly list the persona's interests.
      - If the section is "Frustrations", directly outline the persona's frustrations.
    - The aim is to fill the section with content that is immediately relevant and useful, avoiding unnecessary introductions or conclusions.

    Please craft your response with the above persona details and guidance in mind, ensuring it adheres to the word limit and directly addresses the section's theme.

    `,
  PERSONA_SECTION_LIST_ITEM: ({ cardName, personaName, occupation, age, gender, language = 'English', existingItems }) => `Given the persona details, generate a single, concise section of content tailored specifically for the persona. This content should be relevant, direct, and under 50 words per item, aligning closely with the section's theme. Provide 3 to 5 items for this section.


    ${cardName !== "" && ` Determine whether ${cardName} leans more towards a professional or personal theme. If personal, base items more on age and gender; if professional, focus items on the profession.`}

    ${existingItems && `Here are the existing items for the section: \n ${existingItems} \n do not repeat the existing items. use them as inspiration to generate new items.`}
    **Persona Details:**
    - Name: ${personaName}
    - Profession: ${occupation}
    - Age: ${age}
    - Gender: ${gender}

    **Section Title:** ${cardName ? cardName : 'Suggest a section title based on the details provided.'}

    Your response must be in ${language}.

    **Guidance with Examples:**
    - Your response should be directly in line with the section's theme. For instance, if suggesting a "List of Interests," list the persona's interests like so:
    { title: "Interests", items: ["Interest 1", "Interest 2", "Interest 3"] }


    The objective is to fill the section with immediately relevant and useful content, avoiding superfluous introductions or conclusions. With the persona details and this guidance in mind, craft your response to adhere to the word limit while directly addressing the section's theme.

    `,
  PERSONA_SECTION_RATING: ({ cardName, personaName, occupation, age, gender, language = 'English', existingItems }) =>
    `Please generate a unique and insightful Rating section for the given persona, focusing on both common and uncommon professional qualities. Include 3 to 5 ratings, each named creatively with a numerical rating from 0 to 5.

    ${cardName.isEmptyString() && "generate a random creative section title that relates to the Persona Details. This could be professional (related to their profession) or personal (like Personal Interests), formatted as **Section Title: [title]**, with items pertinent to the suggested title."}
    ${!cardName.isEmptyString() && `Determine whether ${cardName} leans more towards a professional or personal theme. Based on ${cardName}, generate rating items that are directly related to the theme, emphasizing aspects relevant to ${occupation}, age, or gender. Format the items as: - [rating label]:[numerical rating]\n`}

    -The response must be written in ${language ?? 'English'}, not surpass 200 words, and follow this structure: '- [rating label]:[numerical rating]'. Do not return any description or details.
    -Ensure a new line for each  item.
    ${existingItems ? `Here are the existing items for the section: \n ${existingItems} \n Do not repeat the existing items. Use them as inspiration to generate new items.` : ""}

    **Persona Details:**

    - Name: ${personaName}
    - Profession: ${occupation}
    - Age: ${age}
    - Gender: ${gender}
    - Language: ${language}

    **Section Title:** ${cardName || 'Generate a random creative section title. and provide the items based on the title.'}

    Base the ratings on unique insights derived from the persona's profile and the section's theme, ensuring that the ratings are both relevant and insightful.
    ** Format:**
    {title: "[Section Title]", items: ["Rating Label 1: Numerical Rating", "Rating Label 2: Numerical Rating", "Rating Label 3: Numerical Rating"]}


    ${!cardName.isEmptyString() && `Example Rating for "Lifestyle and Values":
      {title: "Lifestyle and Values", items: ["Health and Wellness Concern: 4", "Environmental Consciousness: 3", "Value on Work-Life Balance: 3", "Interest in Continuous Learning: 5"]}`
    }
}

    ${cardName.isEmptyString() && `Example rating with Section title Not provided:
      {title: "Digital Experience", items: ["Website Navigation Ease: 4", "Online Support Accessibility: 3", "Digital Engagement: 3"]}`
    }



    Focus on revealing the persona's distinctive professional strengths and areas for development, omitting generic introductions or conclusions.
    `,

  PERSONA_SECTION_SLIDER: ({ cardName, personaName, occupation, age, gender, language, existingItems }) => `
    Please generate a focused and pertinent Slider section for the specified persona, highlighting essential qualities within their professional sphere. Include 3 to 5 slider items, each with a minLabel, maxLabel, and a numerical rating from 0 to 10.

    ${cardName.isEmptyString() && "generate a random creative section title that relates to the Persona Details. This could be professional (related to their profession) or personal (like Personal Interests), formatted as **Section Title: [title]**, with items pertinent to the suggested title."}

    -The response must be written in ${language ?? 'English'}, not surpass 200 words, and follow this structure: '- [minLabel]:[numerical rating]:[maxLabel]'. Do not return any description or details.
    -Ensure a new line for each slider item.

    ${!cardName.isEmptyString() && `Determine whether ${cardName} leans more towards a professional or personal theme. Based on ${cardName}, generate slider items that are directly related to the theme, emphasizing aspects relevant to ${occupation}, age, or gender. Format the items as: - [minLabel]:[numerical rating]:[maxLabel]\n`}

    ${existingItems ? `Here are the existing items for the section: \n ${existingItems} \n Do not repeat the existing items. Use them as inspiration to generate new items.` : ""}

    Persona Details:

    -Name: ${personaName}
    -Profession: ${occupation}
    -Age: ${age}
    -Gender: ${gender}
    -Language: ${language}

    **Section Title: ${cardName || 'Not provided'}**

    The slider items should be closely related to the theme of the Section Title provided.

    **Guidance with Examples:**
    - If the section is "Personality," generate items that reflect the persona's personality traits.
    - If the section is "Brand Engagement," generate items that reflect the persona's brand engagement levels.
    - If the section is "Value Proposition," generate items that reflect the persona's value proposition preferences.
    - If the section is "Customer Engagement," generate items that reflect the persona's customer engagement levels.
    ** Format:**
    ${cardName.isEmptyString() && `**Section Title: [Title]**`}
    - [minLabel]:[numerical rating]:[maxLabel]


    ${!cardName.isEmptyString() && `Example Slider for "Brand Engagement":
      {title: "Brand Engagement", items: ["Brand Indifferent: 3: Brand Advocate", "Low Brand Awareness: 2: High Brand Awareness", "Price Driven: 6: Value Driven", "Sporadic Engagement: 5: Consistent Engagement"]}`
    }


    ${cardName.isEmptyString() && `Example Slider for  with Section title Not provided:
      {title: "Personality", items: ["Introvert: 3: Extrovert", "Pessimist: 2: Optimist", "Negative: 3: Positive", "Emotional: 4: Rational"]}`
    }

`,
  PERSONA_SECTION_IMAGE: ({ cardName }) => `
  Generate a realistic and detailed image that embodies the concept of '${cardName}' in its most quintessential form. This image should focus on a single scene or object that best represents the essence and direct interpretation of the title, without abstract elements or symbolic interpretations. Aim for clarity and precision in the depiction, highlighting the key features, environment, or aspects that are universally associated with the '${cardName}.' The visual should provide an immediate and clear understanding of the title, serving as a definitive visual representation that can be easily recognized and appreciated for its direct connection to the subject matter
    `,

  CJM_STAGE_DESCRITION: ({ stageName, mapName, language }) => `Generate a description for the ${stageName} stage for the journey map named ${mapName}. response in ${language} language. response in  JSON Format  {"description": "Your concise examples of ${stageName} description in HTML format"} `,
  CJM_STAGE_DESCRIPTION_IMAGE: ({ stageName }) => `create a very simple image of a real person that represent the ${stageName} stage.  The image should be simple, iconic  and easy to understand. and should be with a white theme fitable with different step.
  `,
  CJM_TEXT_SWIMLANES: ({ stageName, mapName, language, swimlanesName }) => `
  Generate examples or insights for a customer experience (CX) journey map. Focus on a specific stage and swimlane. Provide the information in bullet points or a paragraph, as expected by a CX professional.
  The response should be labeled "description" and begin directly with relevant content, without introductory sentences.
   Use concise language and ensure the response is under 200 words, contained within the "description" attribute.

  - Target subject : ${swimlanesName}
  - Stage name: ${stageName}
  - Map name: ${mapName}
  - Language for the response:  ${language}

 ** Requirement:**
 -  Do not repeat the Stage name and the Map name in the response.
 - response in  JSON Format  as follows: {"description": "Your concise examples of ${swimlanesName} or insights here in a bullet point or paragraph format using in HTML format."}

  `,
  CJM_TOUCHPOINTS: ({ stageName, mapName, existingTouchpoints }) => `Generate a list of touchpoints for the '${stageName}' stage in the journey map called '${mapName}'.
  pick between 2 - 5 the relevant one in the following list ${existingTouchpoints}.it has to relevant to the stage and the map. if none of the touchpoints are relevant, generate new ones.
  return straight {touchpoints: [your response]}.`,
  CJM_OPP_FROM_INSIGHT: ({
    stageName,
    mapName,
    language,
    insightName,
    insightType,
    touchpointName,
    interactionDescription,
    mapDescription,
    existingItems
  }) => `
    Generate 3 actionable CX opportunities based on the insight '${insightName}' (${insightType}) within the '${stageName}' stage of the journey map '${mapName}'.
  
    **Definition of an Opportunity:**  
    An opportunity is a concrete improvement or innovation that enhances the customer experience by addressing pain points, unmet needs, or gaps in the current journey. Each opportunity should be **directly linked to the insight** and **provide a clear, actionable path for enhancement**.
  
    **Key Context:**  
    - Persona's interaction: '${interactionDescription}'  
    - Touchpoints involved: '${touchpointName}'  
    - Map overview: '${mapDescription}'  
    - The response should align with the persona’s needs and expectations.  
  
    **Format:**  
    Respond in **concise JSON format** (under 300 words), following this structure:  
    \`\`\`json
    {
      "items": [
        { "title": "Opportunity name 1", "description": "Description of opportunity 1" },
        { "title": "Opportunity name 2", "description": "Description of opportunity 2" },
        { "title": "Opportunity name 3", "description": "Description of opportunity 3" }
      ]
    }
    \`\`\`
  
    ${existingItems ? `Ensure that the generated opportunities are **completely different** from these existing items: ${existingItems}` : ""}
    
    **Language:** Respond in '${language}'.
  `,
  CJM_SOL_FROM_INSIGHT: ({
    stageName,
    mapName,
    language,
    insightName,
    insightType,
    touchpointName,
    interactionDescription,
    mapDescription,
    existingItems
  }) => `
    Generate **3 actionable CX solutions** based on the insight '${insightName}' (${insightType}) within the '${stageName}' stage of the journey map '${mapName}'.
  
    **Definition of a Solution:**  
    A solution is a specific action, tool, or change designed to **address an identified opportunity**. It is the implementation of a strategy to resolve a problem, enhance customer experience, or meet an unmet need. Each solution must be **directly linked to the insight** and provide a **clear, actionable path** for improvement.
  
    **Key Context:**  
    - **Persona's Interaction:** '${interactionDescription}'  
    - **Touchpoints Involved:** '${touchpointName}'  
    - **Journey Map Overview:** '${mapDescription}'  
    - **Align with the persona’s needs and expectations.**  
  
    **Response Format (JSON):**  
    Each solution should be **detailed, structured, and formatted in HTML** for better readability.  
  
    \`\`\`json
    {
      "items": [
        {
          "title": "Solution 1 (e.g., 'Personalized Recommendations')",
          "description": "Provide a clear and structured explanation in HTML format (around 150 words), focusing on benefits, implementation, and impact on CX.",
          "CustomerAffected": { "rate": "1 (low) to 5 (high)" },
          "CustomerBenefit": { "rate": "1 (low) to 5 (high)" },
          "PotentialRevenueIncrease": { "rate": "1 (low) to 5 (high)" },
          "ImproveBrandImage": { "rate": "1 (low) to 5 (high)" },
          "ImplementationCost": { "rate": "1 (low) to 5 (high)" },
          "ImplementationComplexity": { "rate": "1 (low) to 5 (high)" },
          "ImplementationEffort": { "rate": "1 (low) to 5 (high)" },
          "ImplementationTime": { "rate": "1 (low) to 5 (high)" },
          "people": { "description": "Who will be affected and how? Provide a clear explanation in HTML format." },
          "process": { "description": "What step changes are needed? Provide a clear explanation in HTML format." },
          "technology": { "description": "What upgrades or swaps are needed? Provide a clear explanation in HTML format." },
          "values": { "description": "How will this improve the experience or add value? Provide a clear explanation in HTML format." },
          "keymetrics": { "description": "What key metrics will be impacted? Use bullet points in HTML format." }
        },
        {
          "title": "Solution 2 (e.g., 'Automated Support System')",
          "description": "Provide a clear and structured explanation in HTML format (around 150 words), focusing on benefits, implementation, and impact on CX.",
          "CustomerAffected": { "rate": "1 (low) to 5 (high)" },
          "CustomerBenefit": { "rate": "1 (low) to 5 (high)" },
          "PotentialRevenueIncrease": { "rate": "1 (low) to 5 (high)" },
          "ImproveBrandImage": { "rate": "1 (low) to 5 (high)" },
          "ImplementationCost": { "rate": "1 (low) to 5 (high)" },
          "ImplementationComplexity": { "rate": "1 (low) to 5 (high)" },
          "ImplementationEffort": { "rate": "1 (low) to 5 (high)" },
          "ImplementationTime": { "rate": "1 (low) to 5 (high)" },
          "people": { "description": "Who will be affected and how? Provide a clear explanation in HTML format." },
          "process": { "description": "What step changes are needed? Provide a clear explanation in HTML format." },
          "technology": { "description": "What upgrades or swaps are needed? Provide a clear explanation in HTML format." },
          "values": { "description": "How will this improve the experience or add value? Provide a clear explanation in HTML format." },
          "keymetrics": { "description": "What key metrics will be impacted? Use bullet points in HTML format." }
        },
        {
          "title": "Solution 3",
          "description": "Provide a clear and structured explanation in HTML format (around 150 words), focusing on benefits, implementation, and impact on CX.",
          "CustomerAffected": { "rate": "1 (low) to 5 (high)" },
          "CustomerBenefit": { "rate": "1 (low) to 5 (high)" },
          "PotentialRevenueIncrease": { "rate": "1 (low) to 5 (high)" },
          "ImproveBrandImage": { "rate": "1 (low) to 5 (high)" },
          "ImplementationCost": { "rate": "1 (low) to 5 (high)" },
          "ImplementationComplexity": { "rate": "1 (low) to 5 (high)" },
          "ImplementationEffort": { "rate": "1 (low) to 5 (high)" },
          "ImplementationTime": { "rate": "1 (low) to 5 (high)" },
          "people": { "description": "Who will be affected and how? Provide a clear explanation in HTML format." },
          "process": { "description": "What step changes are needed? Provide a clear explanation in HTML format." },
          "technology": { "description": "What upgrades or swaps are needed? Provide a clear explanation in HTML format." },
          "values": { "description": "How will this improve the experience or add value? Provide a clear explanation in HTML format." },
          "keymetrics": { "description": "What key metrics will be impacted? Use bullet points in HTML format." }
        }
      ]
    }
    \`\`\`
  
    **Response Guidelines:**  
    - Ensure the **"description"** is structured in HTML format (bold, italic, underline, bullet points, and numbered lists where relevant).  
    - Each solution should be **around 150 words** to provide sufficient detail.  
    - If **existing solutions** are provided, generate **completely different solutions** from: ${existingItems ? existingItems : "None"}.  
  
    **Language:** Respond in '${language}'.
  `,
  CJM_OPP: ({
    language, mapName, mapDescription, stageName, allRelatedInsights, allRelatedTouchpoints, relatedOpportunities, relatedSolutions
  }) => `You are a Customer Experience (CX) Strategist specializing in creating innovative opportunities for customer journey maps. Based on the following data, generate 3 specific and actionable CX opportunities for the stage "${stageName}" in the journey map "${mapName}". 

**Context:**
- **Journey Map Description:** ${mapDescription || "No description provided"}
- **Stage Name:** ${stageName}
- **Insights:** ${allRelatedInsights?.length > 0 ? allRelatedInsights.map(i => `[${i.type}] ${i.name}`).join(', ') : "No insights available"}
- **Touchpoints:** ${allRelatedTouchpoints?.length > 0 ? allRelatedTouchpoints.join(', ') : "No touchpoints mapped"}
- **Existing Opportunities:** ${relatedOpportunities?.length > 0 ? relatedOpportunities.join(', ') : "No existing opportunities defined"}

---

### **Requirements:**
1. Generate **3 opportunities** in JSON format.
2. Each opportunity must be in ${language} and must include:
   - **title**: A short, descriptive name for the opportunity.
   - **description**: A **detailed** explanation of the opportunity in **rich HTML format**, structured as follows:
     - A **clear summary** of the opportunity and why it matters.
     - **Key benefits** for both the customer and the business.
     - **How it relates to a specific touchpoint** (if touchpoints are provided). This touchpoint **must match the value in relatedTouchpoint**.
     - **How it addresses a specific insight** (if insights are provided). This insight **must match the value in relatedInsight**.
     - A **structured list** (bullet points or numbered steps) when necessary for clarity.
   - **customerValue**: A grade from 1 to 5 indicating the expected value to the customer (1 = low, 5 = high).
   - **businessValue**: A grade from 1 to 5 indicating the expected value to the business (1 = low, 5 = high).

3. **Data Consistency Rules:**
   - Each opportunity **must relate to exactly one touchpoint** and **one insight** if available.
   - The **touchpoint mentioned in the description must match the value of relatedTouchpoint**.
   - The **insight mentioned in the description must match the value of relatedInsight**.
   - Ensure that insights and touchpoints are **not arbitrarily assigned but derived from the description**.

4. **Conditional Fields:**  
   - Include "relatedTouchpoint" in the response only if touchpoints are provided in the context (i.e., touchpoints is not empty).  
   - Include "relatedInsight" in the response only if insights are provided in the context (i.e., insights is not empty).  

---

### **Output Format:**
Return the opportunities as a JSON array with the following structure:
{
  "items": [
    {
      "title": "Opportunity 1",
      "description": "<p><strong>Overview:</strong> Detailed explanation of the opportunity.</p>
                      <p><strong>Key Benefits:</strong></p>
                      <ul>
                        <li>Improves customer engagement by...</li>
                        <li>Reduces friction at the touchpoint...</li>
                        <li>Enhances business efficiency by...</li>
                      </ul>
                      <p><strong>Connection to Touchpoint:</strong> This solution improves the '<strong>Touchpoint A</strong>' experience by...</p>
                      <p><strong>Connection to Insight:</strong> Addresses '[Insight Type] Insight Name' by...</p>",
      "customerValue": 4,
      "businessValue": 5,
      "relatedTouchpoint": "Touchpoint A",
      "relatedInsight": "[Insight Type] Insight Name"
    },
    {
      "title": "Opportunity 2",
      ...
    },
    {
      "title": "Opportunity 3",
      ...
    }
  ]
}`,
  CJM_CXACTIONS: ({
    language, mapName, mapDescription, stageName, allRelatedInsights, allRelatedTouchpoints, relatedOpportunities, relatedSolutions
  }) => `You are a **Customer Experience (CX) Strategist**, specializing in designing **actionable CX Actions** for customer journey maps. Your task is to generate **three specific CX Actions** for the stage **"${stageName}"** in the journey map **"${mapName}"**, ensuring they are **strategic, relevant, and well-structured**.

---
### **Context:**
- **Journey Map:** ${mapDescription || "No description provided"}
- **Stage:** ${stageName}
- **Insights:** ${allRelatedInsights?.length > 0 ? allRelatedInsights.map(i => `[${i.type}] ${i.name}`).join(', ') : "No insights available"}
- **Touchpoints:** ${allRelatedTouchpoints?.length > 0 ? allRelatedTouchpoints.join(', ') : "No touchpoints mapped"}
- **Existing Opportunities:** ${relatedOpportunities?.length > 0 ? relatedOpportunities.join(', ') : "No existing opportunities defined"}
- **Existing Solutions:** ${relatedSolutions?.length > 0 ? relatedSolutions.join(', ') : "No existing solutions defined"}

---

### **CX Action Requirements**
Generate exactly **3 CX Actions** in **JSON format**, each containing:

#### **1. General Details**
- **title**: A concise and clear name.
- **description** (rich HTML format):
  - A **clear summary** of the CX Action.
  - **How the action solves the related solution** (if a solution is available).
  - **How the action enhances a touchpoint** (if a solution is not available but touchpoints are provided).
  - **How the action addresses an insight** (if a solution is not available but insights are provided).
  - **Step-by-step implementation** (structured in bullet points or numbered format for clarity).

---

### **Data Consistency Rules**
Each CX Action **must**:
1. **Relate to exactly one existing solution** (if solutions exist).
2. If no solution exists, it must relate to **one touchpoint or one insight**.
3. Ensure references to solutions, insights, and touchpoints are **accurate and logically assigned**.
4. Maintain consistency between **mentioned touchpoints, insights, and solutions** and those in the provided data.
5. Ensure each solution is **unique** and **distinct** from existing cx actions and in ${language} language.


#### **Conditional Fields**
- **"relatedSolution"**: Include **only if solutions are provided**.
- **"relatedTouchpoint"**: Include **only if no solutions exist** but touchpoints are provided.
- **"relatedInsight"**: Include **only if no solutions exist** but insights are provided.

---

### **Expected Output Format**
Return a **JSON array** structured as follows:

{
  "items": [
    {
      "title": "CX Action 1",
      "description": "<p><strong>Overview:</strong> Explanation of the CX Action.</p>
                      <p><strong>How it solves the solution:</strong> Describe how it resolves the associated solution.</p>
                      <p><strong>Implementation Steps:</strong></p>
                      <ul>
                        <li>Step 1: Action to take...</li>
                        <li>Step 2: Improvement...</li>
                        <li>Step 3: Expected outcome...</li>
                      </ul>",
      "relatedSolution": "Solution Name"
    },
    {
      "title": "CX Action 2",
      ...
    },
    {
      "title": "CX Action 3",
      ...
    }
  ]
}`,
  CJM_SOL: ({
    language, mapName, mapDescription, stageName, allRelatedInsights, allRelatedTouchpoints, relatedOpportunities, relatedSolutions
  }) => `You are a **Customer Experience (CX) Strategist**, specializing in designing **actionable solutions** for customer journey maps. Your task is to generate **three specific CX Solutions** for the stage **"${stageName}"** in the journey map **"${mapName}"**, ensuring they are strategic, impactful, and well-structured.
---

### **Context:**
- **Journey Map:** ${mapDescription || "No description provided"}
- **Stage:** ${stageName}
- **Insights:** ${allRelatedInsights?.length > 0 ? allRelatedInsights.map(i => `[${i.type}] ${i.name}`).join(', ') : "No insights available"}
- **Touchpoints:** ${allRelatedTouchpoints?.length > 0 ? allRelatedTouchpoints.join(', ') : "No touchpoints mapped"}
- **Existing Opportunities:** ${relatedOpportunities?.length > 0 ? relatedOpportunities.join(', ') : "No existing opportunities defined"}
- **Existing Solutions:** ${relatedSolutions?.length > 0 ? relatedSolutions.join(', ') : "No existing solutions defined"}

---

### **Solution Generation Logic**
1. **If existing opportunities are available**, all solutions **must** be based on a specific opportunity.
2. **If no opportunities exist**, solutions should be based on **either insights or touchpoints**.

---

### **Solution Requirements**
Generate exactly **3 solutions** in **JSON format**, each containing:

#### **1. General Details**
- **title**: A short, clear name.
- **description** (rich HTML format):
  - A **concise summary** of the problem and why it matters.
  - **Key benefits** for both the customer and the business.
  - **Implementation details**: Steps to execute.
  - **Impact on CX**: Expected improvements.

#### **2. Evaluation Ratings (1-5)**
- **CustomerAffected**  
- **CustomerBenefit**  
- **PotentialRevenueIncrease**  
- **ImproveBrandImage**  
- **ImplementationCost**  
- **ImplementationComplexity**  
- **ImplementationEffort**  
- **ImplementationTime**  

#### **3. Additional Details**
- **People**: Who is impacted?  
- **Process**: What procedural changes are needed?  
- **Technology**: Required tech adjustments.  
- **Values**: Experience and value improvements.  
- **KeyMetrics**: Performance indicators.

---

### **Data Consistency Rules**
Each solution **must**:
1. **Directly relate to an existing opportunity, if opportunities are provided**.
2. **If no opportunities exist, the solution must be based on either a touchpoint or an insight**.
3. Ensure references to insights, touchpoints, and opportunities are **accurate and logically assigned**.
4. Maintain clear alignment between **mentioned touchpoints/opportunities/insights** and those in the provided data.
5. Ensure each solution is **unique** and **distinct** from existing solutions, and generated in ${language} language.

#### **Conditional Fields**
- **"relatedOpportunity"**: Include only if **opportunities are available**.
- **"relatedTouchpoint"**: Include only if **no opportunities exist**, but **touchpoints are provided**.
- **"relatedInsight"**: Include only if **no opportunities exist**, but **insights are provided**.

---

### **Expected Output Format**
Return a **JSON array** structured as follows:

{
  "items": [
    {
      "title": "Solution 1",
      "description": "<p>Clear explanation in HTML format...</p>",
      "relatedOpportunity": "Opportunity A",
      "ratings": {
        "CustomerAffected": 4,
        "CustomerBenefit": 5,
        "PotentialRevenueIncrease": 3,
        "ImproveBrandImage": 4,
        "ImplementationCost": 2,
        "ImplementationComplexity": 3,
        "ImplementationEffort": 4,
        "ImplementationTime": 3
      },
      "details": {
        "people": "<p>Explanation...</p>",
        "process": "<p>Explanation...</p>",
        "technology": "<p>Explanation...</p>",
        "values": "<p>Explanation...</p>",
        "keyMetrics": "<ul><li>Metric 1</li><li>Metric 2</li></ul>"
      }
    },
    {
      "title": "Solution 2",
      ...
    },
    {
      "title": "Solution 3",
      ...
    }
  ]`,
  CJM_INSIGHT: ({
    language, mapName, mapDescription, stageName, allRelatedTouchpoints, insightTypes, relatedInsights
  }) => `You are a **Customer Experience (CX) Strategist**, specializing in identifying **actionable insights** for customer journey maps. Your task is to generate **three specific CX Insights** for the stage **"${stageName}"** in the journey map **"${mapName}"**, ensuring they are **meaningful, data-driven, and well-structured**.
  
  ---
  
  ### **Context:**
  - **Journey Map:** ${mapDescription || "No description provided"}
  - **Stage:** ${stageName}
  - **Touchpoints:** ${allRelatedTouchpoints?.length > 0 ? allRelatedTouchpoints.join(', ') : "No touchpoints mapped"}
  - **Existing Insights:** ${relatedInsights?.length > 0 ? relatedInsights.join(', ') : "No existing insights defined"}
  - ""Insight Types Available: ${insightTypes?.length > 0 ? insightTypes.join(', ') : "No insight types available"}
  
  ---
  ### **Insight Generation Logic**
1. **If existing insights are available**, ensure that new insights are **distinct** and **complementary** to existing ones.
2. **If insight types are provided**, each insight **must** align with a valid insight type.
3. **If touchpoints are provided**, each insight **must** be linked to a relevant touchpoint.

---
  ### **Insight Requirements**
  Generate exactly **3 insights** in **JSON format**, each containing:
  
  #### **1. General Details**
  - **name**: A concise, descriptive title for the insight.
  - **description** (rich HTML format):
    - A **clear summary** of the insight.
    - **Key observations** about customer behavior, needs, or pain points.
    - **Potential implications** for improving the customer journey.
    - Use **bullet points or structured formatting** when necessary for clarity.
  - **type**: Assign one of the available **insightTypes**.

  #### **2. Data Consistency Rules**
 1. If insight types are provided, each insight **must be assigned a valid insight type**.
2. If touchpoints are provided, each insight **must be linked to a related touchpoint**.
3. The **relatedTouchpoint field must match one of the provided touchpoints**.
4. New insights **must not duplicate existing insights** but should be **complementary**.
5. Ensure insights are **unique, distinct, and relevant to the journey stage** and generated in ${language} language.


  #### **Conditional Fields**
  - **"type"**: Include **only if insight types are available**.
  - **"relatedTouchpoint"**: Include **only if touchpoints are provided**.
  
  ---
  
  ### **Expected Output Format**
  Return a **JSON array** structured as follows:
  
  {
    "items": [
     {
      "title": "Insight 1",
      "type": "Behavioral Insight",
      "description": "<p>Clear explanation in HTML format...</p>",
      "relatedTouchpoint": "Touchpoint A"
    },
    {
      "title": "Insight 2",
      "type": "Pain Point",
      "description": "<p>Clear explanation in HTML format...</p>",
      "relatedTouchpoint": "Touchpoint B"
    },
    {
      "title": "Insight 3",
      "type": "Opportunity Insight",
      "description": "<p>Clear explanation in HTML format...</p>",
      "relatedTouchpoint": "Touchpoint C"
    }
    ]
  }`


}

